import styled, { css } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

import ContactBoxHeader from "../ContactBoxHeader";

export const ContactBoxWrapper = styled.div`
  border: 2px solid ${colors.pureBlack};
  min-width: 300px;
  position: relative;
  text-align: left;
  width: 100%;

  ${props =>
    props.isMobile &&
    css`
      border: none;
    `}
`;

export const ContactBoxContents = styled.div`
  padding: 20px;

  ${ContactBoxHeader} ~ & {
    margin-top: -20px;
  }

  ${props =>
    props.noPadding &&
    css`
      padding: 0;
    `}
`;
